import { languageMatches } from '@cmsgov/design-system';

/**
 * Returns a link pointing to the opposite locale
 */
export default function localeLink(t, locale) {
  var subpath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var switchLocaleLink = arguments.length > 3 ? arguments[3] : undefined;
  var defaultLocaleLink = languageMatches(locale, 'es') ? "https://www.healthcare.gov/".concat(subpath) : "https://www.cuidadodesalud.gov/es/".concat(subpath);
  return {
    label: languageMatches(locale, 'es') ? t('header.english') : t('header.español'),
    ariaLabel: t('header.langAriaLabel'),
    href: switchLocaleLink !== null && switchLocaleLink !== void 0 ? switchLocaleLink : defaultLocaleLink
  };
}